import { ELIGIBILITY_TYPE } from '../const/eligibilityType';
import { promoTypes } from '../const/productType';
import { isIntroRateLoanPromoAvailableForAutopay } from '../helpers/parseEligibility';
import { isIntroRateLoanEnrolled, isWaivedInterestEnrolled } from '../helpers/productTypeHelpers';
import { getValues } from '../xform';
export const getPaymentOptionAndMethod = (form, alternatePaymentMethods, paymentMethods) => {
    const allPaymentMethods = [
        ...paymentMethods.paymentMethods,
        ...alternatePaymentMethods.paymentMethods
    ];
    const paymentForm = getValues(form.getSnapshot().context.actors);
    const paymentMethod = allPaymentMethods === null || allPaymentMethods === void 0 ? void 0 : allPaymentMethods.find((method) => {
        return `${method === null || method === void 0 ? void 0 : method.id}` === (paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm.paymentMethod);
    });
    return [paymentForm.paymentOption, paymentMethod];
};
export const getPaymentFlowFormValues = (context) => {
    const { alternatePaymentMethodsQueryResult, paymentMethodsQueryResult } = context.apiMachineRef.getSnapshot().context;
    return getPaymentOptionAndMethod(context.form, alternatePaymentMethodsQueryResult.data, paymentMethodsQueryResult.data);
};
export const constructEligibilityQueryParams = (featureFlag) => {
    const paymentCapabilityEligibilityArr = [
        ELIGIBILITY_TYPE.ALLOWED_PAYMENT_METHODS,
        ELIGIBILITY_TYPE.AUTOPAY
    ];
    if (featureFlag.isWaivedInterestEnabled) {
        paymentCapabilityEligibilityArr.push(ELIGIBILITY_TYPE.PAYMENT_OPTION);
    }
    if (featureFlag.isSecuredInstallmentEnabled) {
        paymentCapabilityEligibilityArr.push(ELIGIBILITY_TYPE.ONE_TIME_PAYMENT);
    }
    return paymentCapabilityEligibilityArr;
};
export const getAnalyticsMessageType = (apiMachineRef, paymentType, paymentOption) => {
    const api = apiMachineRef.getSnapshot().context;
    const { product, enrollments } = api.accountSummaryQueryResult.data;
    const isIRLActive = isIntroRateLoanPromoAvailableForAutopay(api.paymentEnterpriseEligibilityQueryResult.data);
    let productEnrollmentMessageType;
    if (isWaivedInterestEnrolled(product.type, enrollments)) {
        productEnrollmentMessageType = promoTypes.WAIVED_INTEREST;
    }
    else if (isIntroRateLoanEnrolled(product.type, enrollments)) {
        if (isIRLActive) {
            productEnrollmentMessageType = promoTypes.INTRO_RATE_ACTIVE;
        }
        else {
            productEnrollmentMessageType = promoTypes.INTRO_RATE_EXPIRED;
        }
    }
    else {
        return undefined;
    }
    if (paymentType)
        productEnrollmentMessageType = `${productEnrollmentMessageType}_${paymentType}`;
    if (paymentOption)
        productEnrollmentMessageType = `${productEnrollmentMessageType}_${paymentOption}`;
    return productEnrollmentMessageType;
};
